import { CheckboxComponentProps } from './checkbox.model';
import CheckboxView from './checkbox.view';

// Decision making component
// This component will be responsible for deciding which UI to render
// based on the current state of the application
export const CheckboxController = (props: CheckboxComponentProps) => {
  return <CheckboxView {...props} />;
};
